import { render, staticRenderFns } from "./CallNormalAuthPop.vue?vue&type=template&id=1aa5ae34&scoped=true&"
import script from "./CallNormalAuthPop.vue?vue&type=script&lang=js&"
export * from "./CallNormalAuthPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa5ae34",
  null
  
)

export default component.exports